// src/utils/fetchUnassignedChildren.js
import http from "../api/apiClient";

export async function fetchUnassignedChildren() {
  const res = await http.get("/reports/unassigned-children");
  // backend geeft een lijst van ChildDTO terug
  return Array.isArray(res.data) ? res.data : [];
}